import { render, staticRenderFns } from "./Single_contactUs.vue?vue&type=template&id=64377984&scoped=true"
import script from "./Single_contactUs.vue?vue&type=script&lang=js"
export * from "./Single_contactUs.vue?vue&type=script&lang=js"
import style0 from "./Single_contactUs.vue?vue&type=style&index=0&id=64377984&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64377984",
  null
  
)

export default component.exports